import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertValueToUSD } from '../../../helpers/currency.helper';
import { ReactComponent as IconBank } from '../../../assets/svg/shared/payment-methods/icon-bank.svg';

interface IAmountPageAccountDetailsProps {
  balance: number
}

const STYLES = {
  WRAPPER: 'mt-[64px] w-[375px] flex justify-between',
  BALANCE_TITLE: 'text-[12px] text-bw07 font-metricR',
  BALANCE_VALUE: 'text-md text-action03 font-metricRMedium text-right',
  ACCOUNT_TITLE: 'ml-[5px] text-md text-bw07 font-metricRMedium',
};

const AmountPageAccountDetails = ({ balance }: IAmountPageAccountDetailsProps) => {
  const { t } = useTranslation();
  return (
    <div className={STYLES.WRAPPER}>
      <div className='flex items-center'>
        <IconBank />
        <div className={STYLES.ACCOUNT_TITLE}>{t('BANK_TRANSFER_REDESIGN.AMOUNT_STEP.CHECKING_ACCOUNT')}</div>
      </div>
      <div>
        <div className={STYLES.BALANCE_TITLE}>{t('BANK_TRANSFER_REDESIGN.AMOUNT_STEP.AVAILABLE_BALANCE')}</div>
        <div className={STYLES.BALANCE_VALUE} data-testid='SendMoneyAmountPage-availableBalance'>{convertValueToUSD(balance, 2)}</div>
      </div>
    </div>
  );
};

export default AmountPageAccountDetails;
